"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _row = _interopRequireDefault(require("@amzn/meridian/row"));
var _column = _interopRequireDefault(require("@amzn/meridian/column"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _im = require("react-icons/im");
var _css = require("@emotion/css");
var _colorStyles = _interopRequireDefault(require("../enums/colorStyles"));
var _useResponse2 = _interopRequireDefault(require("../hooks/useResponse"));
var _getRatings = _interopRequireDefault(require("../utils/getRatings"));
var _Question = _interopRequireDefault(require("./Question"));
var _templateObject, _templateObject2;
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StarRating = function StarRating(_ref) {
  var question = _ref.question,
    responseForQuestion = _ref.responseForQuestion,
    id = _ref.id,
    isMandatory = _ref.isMandatory,
    minRatingValue = _ref.minRatingValue,
    ratingInterval = _ref.ratingInterval,
    questionTextFormat = _ref.questionTextFormat,
    numberOfIntervals = _ref.numberOfIntervals;
  var ratingAnswer = responseForQuestion.answer;
  var _useState = (0, _react.useState)(ratingAnswer),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    rating = _useState2[0],
    setRating = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    hoveredRating = _useState4[0],
    setHoveredRating = _useState4[1];
  var _useResponse = (0, _useResponse2["default"])(),
    saveFeedbackResponse = _useResponse.saveFeedbackResponse;
  var onClickHandler = function onClickHandler(value) {
    setRating(value);
    saveFeedbackResponse({
      id: id,
      answer: value
    });
  };
  var ratings = (0, _getRatings["default"])(minRatingValue, ratingInterval, numberOfIntervals);
  var setColour = function setColour(colorValue, ratingValue) {
    return rating >= ratingValue || hoveredRating >= ratingValue ? colorValue : _colorStyles["default"].DEFAULT;
  };
  return /*#__PURE__*/_react["default"].createElement(_column["default"], {
    spacingInset: "xxsmall"
  }, /*#__PURE__*/_react["default"].createElement(_Question["default"], {
    questionTextFormat: questionTextFormat,
    question: question,
    isMandatory: isMandatory
  }), /*#__PURE__*/_react["default"].createElement(_row["default"], null, ratings.map(function (ratingVal) {
    return /*#__PURE__*/_react["default"].createElement("label", {
      className: (0, _css.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n              & > svg {\n                transition: color 0.5s ease-in-out;\n              }\n              &:hover {\n                transform: scale(1.5);\n                transition: all 0.2s ease-in-out;\n              }\n            "])))
    }, /*#__PURE__*/_react["default"].createElement("input", {
      type: "radio",
      onClick: function onClick() {
        return onClickHandler(ratingVal);
      },
      className: (0, _css.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n                & {\n                  display: none;\n                }\n              "])))
    }), /*#__PURE__*/_react["default"].createElement(_im.ImStarFull, {
      "aria-label": "star".concat(ratingVal),
      size: 50,
      color: setColour(_colorStyles["default"].STAR, ratingVal),
      onMouseEnter: function onMouseEnter() {
        return setHoveredRating(ratingVal);
      },
      onMouseLeave: function onMouseLeave() {
        return setHoveredRating(null);
      },
      style: {
        cursor: 'pointer'
      }
    }));
  })));
};
StarRating.propTypes = {
  question: _propTypes["default"].string.isRequired,
  responseForQuestion: _propTypes["default"].object,
  id: _propTypes["default"].string.isRequired,
  isMandatory: _propTypes["default"].bool.isRequired,
  minRatingValue: _propTypes["default"].number,
  ratingInterval: _propTypes["default"].number,
  questionTextFormat: _propTypes["default"].string,
  numberOfIntervals: _propTypes["default"].number
};
StarRating.defaultProps = {
  minRatingValue: 1,
  responseForQuestion: {
    answer: null
  },
  ratingInterval: 1,
  questionTextFormat: '',
  numberOfIntervals: 5
};
var _default = exports["default"] = StarRating;
//# sourceMappingURL=StarRating.js.map